/**
 * Links that leave the console.
 *
 * Each one used to be a literal `https://*.repletoryreach.local` host that
 * resolves nowhere, so the help icon and the status-page entry were dead ends
 * that looked live. They are configuration now: set the variable and the
 * affordance appears, leave it unset and nothing offers the user a broken
 * link. The tenant console keeps its dev-server default so the wrong-domain
 * escape hatch works on a developer's machine without any setup.
 */

const env = import.meta.env;

/** Operator documentation. Unset in every environment so far. */
export const DOCS_URL: string = env.VITE_DOCS_URL ?? '';

/** Public status page. */
export const STATUS_URL: string = env.VITE_STATUS_URL ?? '';

/** Where a tenant user belongs when they land on the admin sign-in. */
export const TENANT_CONSOLE_URL: string =
  env.VITE_TENANT_UI_URL ?? (env.DEV ? 'http://localhost:3006' : '');
